@if (loading()) {
	<lb-loader message="Loading lesson details..."></lb-loader>
} @else if (resourceError(); as error) {
	<lb-resource-error [type]="error" resourceLabel="lesson" [backLink]="lessonsLink()" backLabel="All Lessons"></lb-resource-error>
} @else if (lesson()) {
	<div class="lesson-wrapper">
		<div class="lesson-wrapper__back">
			<button md-button (click)="goBack()">
				<md-icon icon="untitled-ui/arrows/arrow-left"></md-icon>
				All Lessons
			</button>
			<span class="lesson-wrapper__spacer"></span>
			@if (enrollmentGUID() && state.isAdmin()) {
				<lb-external-links [entityGuid]="enrollmentGUID()!" [entityType]="'Enrollment'" [mode]="'compact'"></lb-external-links>
			}
		</div>
		<!-- Two-column lesson content (daily grades, objectives, project, independent work | summary) -->
		@if (userView === 'learner') {
			<lb-learner-lesson-detail></lb-learner-lesson-detail>
		} @else {
			<lb-instructor-lesson-detail></lb-instructor-lesson-detail>
		}
	</div>
}
